export enum OPERATION_REQUEST_STATUS {
    OPERATION_OPEN_REQUEST_STATUS = 'requestNew',
    OPERATION_INPROGRESS_REQUEST_STATUS = 'requestOpen',
    OPERATION_COMPLETED_REQUEST_STATUS = 'requestCompleted',
}

export enum OPERATION_REQUEST_STATUS_BG {
    OPERATION_INPROGRESS_REQUEST_STATUS = '#ff6a3933',
    OPERATION_COMPLETED_REQUEST_STATUS = '#00c48c33',
    OPERATION_OPEN_REQUEST_STATUS = 'rgba(251, 55, 94, 0.2)'
}

export enum OPERATION_REQUEST_STATUS_COLOR {
    OPERATION_INPROGRESS_REQUEST_STATUS = '#ff6a39',
    OPERATION_COMPLETED_REQUEST_STATUS = '#00c48c',
    OPERATION_OPEN_REQUEST_STATUS = 'rgba(251, 55, 94, 1)'
}